import React, { useState } from 'react';
import './Navbar.css';
import logo from '../../assets/yonloıgo.png'

function Navbar() {
  const [isOpen, setIsOpen] = useState(false); 
  const [activeDropdown, setActiveDropdown] = useState(null); 

  const navLinks = [
    { name: 'ANA SAYFA', link: '/' },
    { 
      id: 'kongre', 
      name: 'KONGRE', 
      link: '#',
      subLinks: [
        { name: 'Kongre Hakkında', link: '/hakkinda' },
        { name: 'Kongre Programı', link: '/program' },
        { name: 'Alanlar ve Koordinatörler', link: '/alanlar' },
        { name: 'Danışma Kurulu', link: '/danisma' },
        { name: 'Düzenleme Kurulu', link: '/duzenleme' }
      ]
    },
    { 
      id: 'bildiriler', 
      name: 'BİLDİRİLER', 
      link: '#',
      subLinks: [
        { name: 'Bildiri Gönderimi', link: '/bildiri-gonderimi' },
        { name: 'Bildiri Değerlendirme Süreci', link: '/degerlendirme-sureci' },
        { name: 'Değerlendirme Ölçütleri', link: '/olcutler' },
        { name: 'Bildiri Yazım Kuralları', link: '/yazim-kurallari' },
        { name: 'Kabul Edilen Bildiriler', link: '/kabul-edilenler' },
        { name: 'Önemli Tarihler', link: '/onemli-tarihler' }
      ]
    },
    { name: 'YAYIN OLANAKLARI', link: '/yayin' },
    { 
      id: 'kayit-ucret',
      name: 'KAYIT & ÜCRET', 
      link: '#',
      subLinks: [
        { name: 'Kayıt', link: '/kayit' },
        { name: 'Katılım Ücreti', link: '/katilim-ucreti' }
      ]
    },
    { name: 'ÇALIŞTAY', link: '/calistay' },
    
    { 
      id: 'konaklama',
      name: 'KONAKLAMA', 
      link: '/konaklama' 
    },
    { name: 'ULAŞIM', link: '/ulasim' },  
  ];

  return (
    <nav className="navbar-container">
      <div className="navbar-top">
        <div className="navbar-logo"><img src={logo} alt="Logo" /></div>
        <div className="logo-text"><h1>34. ULUSAL YÖNETİM VE ORGANİZASYON KONGRESİ</h1></div>
        <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          <span className={isOpen ? "bar open" : "bar"}></span>
          <span className={isOpen ? "bar open" : "bar"}></span>
          <span className={isOpen ? "bar open" : "bar"}></span>
        </div>
      </div>

      <div className={`navbar-bottom ${isOpen ? "show-menu" : ""}`}>
        <ul className="nav-links">
          {navLinks.map((item, index) => (
            <li 
              key={index} 
              className={item.subLinks ? "dropdown-item" : ""}
              onMouseEnter={() => item.id && setActiveDropdown(item.id)}
              onMouseLeave={() => setActiveDropdown(null)}
              onClick={() => item.id && setActiveDropdown(activeDropdown === item.id ? null : item.id)}
            >
              <a href={item.link}>{item.name}</a>
              
              {item.subLinks && (
                <ul className={`dropdown-menu ${activeDropdown === item.id ? "active" : ""}`}>
                  {item.subLinks.map((sub, i) => (
                    <li key={i}><a href={sub.link}>{sub.name}</a></li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;